import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

/**
 * Component for displaying validation errors for a form field.
 * @param children - The content to display.
 * @param className - The class name to apply to the component.
 * @param style - The style to apply to the component.
 * @returns The ValidationError component.
 */
export const ValidationError = ({
  children,
  className,
  style,
}: PropsWithChildren & ComponentStyling) => {
  return (
    <small
      data-is-invalid={Boolean(children)} // data-attribute can be used to target errors; f.i. for scrolling to the next validation error
      className={cn(
        'absolute bottom-0 left-0 z-10 translate-y-full bg-white/90 px-1 py-0.5 text-left text-xs leading-none text-tiga-semantic-error',
        className,
      )}
      role="alert"
      style={style}
    >
      {children}
    </small>
  );
};
